<div class="category-detail" *ngIf="category">
  <div class="header-category-detail">
      <!-- Header -->
  <div class="detail-header">
    <button class="back-button" (click)="goBack()">
      <img src="../../../assets/back.svg" alt="back" onerror="this.textContent='‹'" />
    </button>
    <h1 class="header-title">{{ categoryName }}</h1>
  </div>

  <!-- Search -->
  <div class="search-wrapper">
    <input
      type="text"
      class="search-input"
      [placeholder]="'menu.search.placeholder' | translate"
      [(ngModel)]="searchText" />
  </div>

  <!-- Tab bar for subcategories -->
  <app-menu-tab-bar
    *ngIf="hasSubcategories && !searchText"
    [items]="tabItems"
    [selectedId]="selectedTabId"
    (tabSelected)="onTabSelected($event)">
  </app-menu-tab-bar>
  </div>

  <!-- Content -->
  <div class="product-list container" [style.marginTop]="hasSubcategories ? '192px' : '140px'">
    <!-- Search results -->
    <ng-container *ngIf="searchText">
      <div class="empty-search" *ngIf="filteredProducts.length === 0">
        <p>{{ 'menu.noProducts' | translate }}</p>
      </div>
      <ng-container *ngIf="filteredProducts.length > 0">
        <app-product-list-item
          *ngFor="let product of filteredProducts"
          [product]="product"
          [currencySymbol]="currencySymbol"
          [clientData]="clientData"
          [cartQuantity]="getItemQuantity(product.id)"
          [orderingEnabled]="canEnableOrdering()"
          [cartSource]="'category_detail'"
          (productClicked)="onProductClick($event)"
          (sheetRequested)="onProductClick($event)"
          (addToCartClicked)="addToCart($event, product)"
          (quantityChanged)="updateQuantity($event.event, product, $event.change)">
        </app-product-list-item>
      </ng-container>
    </ng-container>

    <!-- Tabbed content (subcategories) -->
    <ng-container *ngIf="!searchText && hasSubcategories">
      <app-product-list-item
        *ngFor="let product of displayedProducts"
        [product]="product"
        [currencySymbol]="currencySymbol"
        [clientData]="clientData"
        [cartQuantity]="getItemQuantity(product.id)"
        [orderingEnabled]="canEnableOrdering()"
        [cartSource]="'category_detail'"
        (productClicked)="onProductClick($event)"
        (sheetRequested)="onProductClick($event)"
        (addToCartClicked)="addToCart($event, product)"
        (quantityChanged)="updateQuantity($event.event, product, $event.change)">
      </app-product-list-item>
    </ng-container>

    <!-- Flat content (no subcategories) -->
    <ng-container *ngIf="!searchText && !hasSubcategories">
      <app-product-list-item
        *ngFor="let product of flatProducts"
        [product]="product"
        [currencySymbol]="currencySymbol"
        [clientData]="clientData"
        [cartQuantity]="getItemQuantity(product.id)"
        [orderingEnabled]="canEnableOrdering()"
        [cartSource]="'category_detail'"
        (productClicked)="onProductClick($event)"
        (sheetRequested)="onProductClick($event)"
        (addToCartClicked)="addToCart($event, product)"
        (quantityChanged)="updateQuantity($event.event, product, $event.change)">
      </app-product-list-item>
    </ng-container>
  </div>
</div>

<!-- Unavailable product alert -->
<div class="backdrop" *ngIf="showUnavailableAlert" @fadeInOut (click)="showUnavailableAlert = false"></div>
<div class="unavailable-alert" *ngIf="showUnavailableAlert" @fadeInOut>
    <h3>{{ 'menu.availability.notAvailable' | translate }}</h3>
    <p>{{ unavailableAlertMessage }}</p>
    <button (click)="showUnavailableAlert = false">OK</button>
</div>

<app-floating-cart></app-floating-cart>
